export const DealerType = {
    RCI: 1,
    UCL: 2
} as const

export type DealerType = typeof DealerType[keyof typeof DealerType]

export const DealerTypes: [DealerType, string][] = [
    [DealerType.RCI, 'RCI'],
    [DealerType.UCL, 'UCL']
]

export const getDealerTypeName = (type?: DealerType) => {
    const found = DealerTypes.find(x => x[0] === type)
    return found ? found[1] : undefined
}